import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import HeroSection from './components/HeroSection';
import NewsTicker from './components/NewsTicker';
import CompilationGrid from './components/CompilationGrid';
import TopicStrip from './components/TopicStrip';
import HotDiscussion from './components/HotDiscussion';
import ArchiveTimeline from './components/ArchiveTimeline';
import RankingBoard from './components/RankingBoard';

export default function Home() {
  return (
    <div id="top" className="min-h-screen bg-background-50 font-sans text-foreground-950">
      <SiteHeader />
      <main className="w-full">
        <HeroSection />
        <NewsTicker />
        <CompilationGrid />
        <TopicStrip />
        <HotDiscussion />
        <ArchiveTimeline />
        <RankingBoard />
      </main>
      <SiteFooter />
    </div>
  );
}